var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const apiBaseUri = {
    beta: 'https://beta-api.coinapp.co',
    local: 'http://localhost:3030/dev',
    prod: 'https://api.coinapp.co',
};
class PixelApi {
    /* baseUri can either be a preset (prod, beta, local), or a specific uri */
    constructor(baseUri = 'prod') {
        this.endPoint = apiBaseUri[baseUri] ? `${apiBaseUri[baseUri]}/t/event` : baseUri;
    }
    trackEvents(events) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(this.endPoint, events)).data;
        });
    }
}
export default PixelApi;
//# sourceMappingURL=Api.js.map